module.exports = __webpack_public_path__ + "img/rocket.2df786d1.png";